import { ConfigModule } from 'shared/types'
import { controls } from 'shared/components/controls'

export interface CamerasConfig {
	performance: string

	sortByPlace: boolean
	order: 'asc' | 'desc'
	animatedSort: boolean

	showClasses: boolean
	showRaceName: boolean
	showUnit: boolean
	bg1: string
	bg2: string
	bg3: string
	videoSource1: string
	videoSource2: string
	videoSource3: string
	splitCameraCams: number
}

import './blob'
declare module './blob' {
	interface ConfigBlob {
		camerasConfig: CamerasConfig
	}
}

const bgOptions = [
	{ label: 'Blue', value: '#0000FF' },
	{ label: 'Green', value: '#00FF00' },
	{ label : 'Magenta', value: '#FF00FF' },
	{ label: 'Black', value: 'black' },
	{ label: 'White', value: 'white' },
	{ label: 'Alpha Channel', value: 'transparent' },
	{ label: 'Video Stream', value: 'video' }
]

export const camerasConfig: ConfigModule<CamerasConfig> = {
	page: 'cameras',
	panel: 'Options',
	isTheme: false,
	fields: {
		splitCameraCams: {
			default: 3,
			control: controls.Number('Split Camera Cams', 1, 1, 3)
		},
		performance: {
			default: 'behind',
			control: controls.Select('Performance', [
				{ label: 'Units', value: 'units' },
				{ label: 'Units behind leader', value: 'behind' }
			])
		},
		showClasses: {
			default: false,
			control: controls.Checkbox('Show Classes'),
			group: 'Show'
		},
		showRaceName: {
			default: false,
			control: controls.Checkbox('Show Race Name'),
			group: 'Show'
		},
		showUnit: {
			default: true,
			control: controls.Checkbox('Show Unit'),
			group: 'Show'
		},
		order: {
			default: 'asc'
		},
		animatedSort: {
			default: true,
			control: controls.Checkbox('Animated Sort'),
			group: 'Display'
		},
		sortByPlace: {
			default: true,
			control: controls.Checkbox('Sort by Place')
		},
		bg1: {
			default:  'video',
			private: false,
			cams: 1,
			control: controls.Select('First Camera Background', bgOptions)
		},
		bg2: {
			default:  'video',
			private: true,
			cams: 2,
			control: controls.Select('Second Camera Background', bgOptions)
		},
		bg3: {
			default:  'video',
			private: true,
			cams: 3,
			control: controls.Select('Third Camera Background', bgOptions)
		},
		videoSource1: {
			default:  `http://files.concept2.com/v3/1.mp4`,
			private: false,
			cams: 1,
			control: controls.Text('First Camera Video Url'),
			hideDuringRace: false
		},
		videoSource2: {
			default:  `http://files.concept2.com/v3/1.mp4`,
			private: false,
			cams: 2,
			control: controls.Text('Second Camera Video Url'),
			hideDuringRace: false
		},
		videoSource3: {
			default:  `http://files.concept2.com/v3/1.mp4`,
			private: false,
			cams: 3,
			control: controls.Text('Third Camera Video Url'),
			hideDuringRace: false
		},
	}
}
